import prettyBytes from 'pretty-bytes';

export function formatBytes(byteValue: number): string {
  return prettyBytes(byteValue, { maximumFractionDigits: 1, locale: 'de' });
}
